import { createHashHistory } from "history";

export const history = createHashHistory();



// WEBPACK FOOTER //
// ./src/history.js